document.addEventListener('rebuy:cart.change', (event) => {
	$.ajax({
		type: 'GET',
		url: '/cart.js',
		cache: false,
		dataType: 'json',
		success: function (cart) {
			$('.header__icons--cart-open .cart-count').text(cart.item_count)
		},
	})
})

$(document).ready(function () {
	var maxHeightTestimonials = 0
	$('.section--testimonials swiper-container swiper-slide').each(function () {
		var currentHeight = $(this).find('.card--testimonial__content').innerHeight() + 2
		if (currentHeight > maxHeightTestimonials) {
			maxHeightTestimonials = currentHeight
		}
	})
	$('.section--testimonials swiper-container swiper-slide .card--testimonial__content').css(
		'min-height',
		maxHeightTestimonials + 'px'
	)

	var maxHeightBlogPosts = 0
	$('.section--blog-posts swiper-container swiper-slide').each(function () {
		var currentHeight = $(this).find('.card__content').innerHeight() + 2
		if (currentHeight > maxHeightBlogPosts) {
			maxHeightBlogPosts = currentHeight
		}
	})
	$('.section--blog-posts swiper-container swiper-slide .card__content').css('min-height', maxHeightBlogPosts + 'px')
})

$(window).resize(function () {
	var maxHeightTestimonials = 0
	$('.section--testimonials swiper-container swiper-slide').each(function () {
		var currentHeight = $(this).find('.card--testimonial__content').innerHeight() + 2
		if (currentHeight > maxHeightTestimonials) {
			maxHeightTestimonials = currentHeight
		}
	})
	$('.section--testimonials swiper-container swiper-slide .card--testimonial__content').css(
		'min-height',
		maxHeightTestimonials + 'px'
	)

	var maxHeightBlogPosts = 0
	$('.section--blog-posts swiper-container swiper-slide').each(function () {
		var currentHeight = $(this).find('.card__content').innerHeight() + 2
		if (currentHeight > maxHeightBlogPosts) {
			maxHeightBlogPosts = currentHeight
		}
	})
	$('.section--blog-posts swiper-container swiper-slide .card__content').css('min-height', maxHeightBlogPosts + 'px')
})

function l_para_style_pandectes_cookie() {
	// 1. Selector for the Pandectes cookie consent popup
	const hostSelector = 'pandectes-cmp'

	// 2. Define the custom CSS rules for the button inside the shadow DOM
	const cssRules = `
    :is(.widget,.dialog).left {
      --spacing: 0.175em;
      left: 11px !important;
      bottom: 60px !important;
    }

    @media (min-width: 1024px) {
      :is(.widget,.dialog).left {
        --spacing: 0.255em;
        left: 21px !important;
        bottom: 80px !important;
      }
    }
  `

	// 3. Wait for the popup to render, then inject CSS into the Shadow DOM
	const checkExist = setInterval(() => {
		const host = document.querySelector(hostSelector)

		if (host && host.shadowRoot) {
			const style = document.createElement('style')
			style.textContent = cssRules
			host.shadowRoot.appendChild(style)

			clearInterval(checkExist) // Stop the interval once the CSS is successfully injected
		}
	}, 100)

	// Safety timeout: stop checking after 5 seconds to prevent memory leaks if the popup doesn't load
	setTimeout(() => clearInterval(checkExist), 5000)
}

window.addEventListener('DOMContentLoaded', () => {
	l_para_style_pandectes_cookie()
})

// =====================
// String Utilities
// =====================

function l_normalizeString(str) {
	return str
		.normalize('NFD')
		.replace(/\p{Diacritic}/gu, '')
		.toLowerCase()
}

function l_handleize(str) {
	return str
		.normalize('NFD')
		.replace(/[\u0300-\u036f]/g, '')
		.toLowerCase()
		.replace(/[^a-z0-9]+/g, '-')
		.replace(/^-+|-+$/g, '')
		.replace(/--+/g, '-')
}

// =====================
// Focus Management & Trap Focus
// =====================

function l_debounce(fn, wait = 0) {
	let timeoutId

	return function (...args) {
		clearTimeout(timeoutId)
		timeoutId = setTimeout(() => fn.apply(this, args), wait)
	}
}

function isVisible(element) {
	if (!element) return false

	if (element.closest('[aria-hidden="true"], [hidden]')) return false

	const detailsParent = element.closest('details')
	if (detailsParent && !detailsParent.open && !detailsParent.contains(element.closest('summary'))) {
		return false
	}

	if (element.offsetParent === null && getComputedStyle(element).position !== 'fixed') {
		return false
	}

	const style = getComputedStyle(element)
	if (style.visibility === 'hidden' || style.visibility === 'collapse') return false

	if (element.getClientRects().length === 0) return false

	return true
}

function l_getFocusableElements(container) {
	const focusableSelectors = `summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe`

	return Array.from(container.querySelectorAll(focusableSelectors)).filter((el) => isVisible(el))
}

function l_disableFocusableElements(container) {
	l_getFocusableElements(container).forEach((el) => {
		el.setAttribute('tabindex', '-1')
		el.setAttribute('aria-disabled', 'true')
	})
}

function l_enableFocusableElements(container) {
	l_getFocusableElements(container).forEach((el) => {
		el.removeAttribute('tabindex')
		el.removeAttribute('aria-disabled')
	})
}

const l_focusTrapStack = []

function l_createFocusTrapLayer(container, defaultElementToFocus, enableFocusRange = true) {
	const layer = {
		container,
		defaultElementToFocus,
		enableFocusRange,
		_keydownAttached: false,
	}

	layer.handlers = {
		keydown(event) {
			const key = event.code?.toUpperCase()
			const isTab = key === 'TAB'
			const isArrowDown = key === 'ARROWDOWN'
			const isArrowUp = key === 'ARROWUP'

			const elements = l_getFocusableElements(layer.container)
			const [first, last] = [elements[0], elements[elements.length - 1]]
			const currentIndex = elements.indexOf(event.target)

			if (!elements.length) return

			if (isTab) {
				if ((event.target === last || last?.contains?.(event.target)) && !event.shiftKey) {
					event.preventDefault()
					first?.focus()
				} else if ((event.target === layer.container || first?.contains?.(event.target)) && event.shiftKey) {
					event.preventDefault()
					last?.focus()
				}
				return
			}

			/* Arrow ↑/↓ only when enableFocusRange — drawers/menus often need native arrows */
			if (!layer.enableFocusRange) return

			if (isArrowDown) {
				event.preventDefault()
				if (currentIndex === -1 || currentIndex === elements.length - 1) {
					first?.focus()
				} else {
					elements[currentIndex + 1]?.focus()
				}
				return
			}

			if (isArrowUp) {
				event.preventDefault()
				if (currentIndex === -1 || currentIndex === 0) {
					last?.focus()
				} else {
					elements[currentIndex - 1]?.focus()
				}
			}
		},
		focusin(event) {
			if (!layer.container.contains(event.target)) return

			if (!layer._keydownAttached) {
				document.addEventListener('keydown', layer.handlers.keydown)
				layer._keydownAttached = true
			}
		},
		focusout() {
			if (!layer._keydownAttached) return

			document.removeEventListener('keydown', layer.handlers.keydown)
			layer._keydownAttached = false
		},
	}

	layer.activate = ({ focus = true } = {}) => {
		document.addEventListener('focusin', layer.handlers.focusin)
		document.addEventListener('focusout', layer.handlers.focusout)

		if (!focus) return

		const elements = l_getFocusableElements(layer.container)
		const elementToFocus = layer.defaultElementToFocus || elements[0]

		if (!elementToFocus) return

		elementToFocus.focus()

		if (
			elementToFocus.tagName === 'INPUT' &&
			['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
			elementToFocus.value &&
			layer.enableFocusRange
		) {
			elementToFocus.setSelectionRange(0, elementToFocus.value.length)
		}
	}

	layer.deactivate = () => {
		document.removeEventListener('focusin', layer.handlers.focusin)
		document.removeEventListener('focusout', layer.handlers.focusout)

		if (layer._keydownAttached) {
			document.removeEventListener('keydown', layer.handlers.keydown)
			layer._keydownAttached = false
		}
	}

	return layer
}

function l_shouldReplaceTrapLayer(topLayer, container) {
	if (!topLayer) return false
	if (topLayer.container === container) return true

	return topLayer.container.contains(container) || container.contains(topLayer.container)
}

function l_trapFocus(container, defaultElementToFocus, enableFocusRange = true, moveFocus = true) {
	const topLayer = l_focusTrapStack.at(-1)

	if (l_shouldReplaceTrapLayer(topLayer, container)) {
		topLayer.deactivate()
		l_focusTrapStack.pop()
	} else {
		topLayer?.deactivate()
	}

	const layer = l_createFocusTrapLayer(container, defaultElementToFocus, enableFocusRange)
	l_focusTrapStack.push(layer)
	layer.activate({ focus: moveFocus })
}

function l_removeTrapFocus(elementToFocus = null) {
	const topLayer = l_focusTrapStack.pop()
	topLayer?.deactivate()

	const previousLayer = l_focusTrapStack.at(-1)

	if (previousLayer) {
		// Resume parent trap (stacked drawers / nested modals), then return focus to the trigger
		previousLayer.activate({ focus: false })
		elementToFocus?.focus?.()
	} else if (elementToFocus) {
		elementToFocus.focus()
	}
}

// =====================
// Scroll & Body Lock Utilities
// =====================

function l_setBodyScrollbarWidth() {
	const scrollBarWidth = window.innerWidth - document.documentElement.clientWidth
	document.documentElement.style.setProperty('--l-body-scrollbar-width', `${scrollBarWidth}px`)
}

function l_lockBodyScroll(elementName) {
	// Add classes
	document.body.classList.add('js-block-page')

	if (elementName) {
		document.body.classList.add(`js-block-page-${elementName}`)
	}
}

function l_unLockBodyScroll(elementName) {
	// Remove classes
	if (elementName) {
		document.body.classList.remove(`js-block-page-${elementName}`)

		const isExistAnotherBlockedClass = Array.from(document.body.classList).some((cls) =>
			cls.startsWith('js-block-page-')
		)

		!isExistAnotherBlockedClass && document.body.classList.remove('js-block-page')
	} else {
		document.body.classList.remove('js-block-page')
	}
}

function l_setupVariablesBeforeOpenModal() {
	// Elements — prefer custom element over hardcoded id
	const headerSection = document.getElementById('nav-wrapper')

	// Set CSS variables
	document.documentElement.style.setProperty('--l-viewport-height', `${visualViewport?.height ?? window.innerHeight}px`)
	document.documentElement.style.setProperty('--l-header-height', `${headerSection?.offsetHeight || 0}px`)
	document.documentElement.style.setProperty('--l-announcement-bar-height', `0px`)

	return {
		headerHeight: headerSection?.offsetHeight || 0,
		announcementBarHeight: 0,
		headerTotalHeight: headerSection?.offsetHeight || 0,
		viewportHeight: visualViewport?.height ?? window.innerHeight,
	}
}

// =====================
// Media Controls
// =====================

function l_pauseAllMedia(container = document) {
	container.querySelectorAll('iframe').forEach((iframe) => {
		const src = iframe.getAttribute('src') || ''
		if (src.includes('youtube')) {
			iframe.contentWindow?.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*')
		} else if (src.includes('vimeo')) {
			iframe.contentWindow?.postMessage('{"method":"pause"}', '*')
		}
	})
	container.querySelectorAll('l-product-model').forEach((model) => {
		if (model.modelViewerUI) model.modelViewerUI.pause()
	})
	container.querySelectorAll('video').forEach((video) => {
		video.pause()
	})
}

function l_playMedia(container = document) {
	container.querySelectorAll('iframe').forEach((iframe) => {
		const src = iframe.getAttribute('src') || ''
		if (src.includes('youtube')) {
			iframe.contentWindow?.postMessage('{"event":"command","func":"playVideo","args":""}', '*')
		} else if (src.includes('vimeo')) {
			iframe.contentWindow?.postMessage('{"method":"play"}', '*')
		}
	})
	container.querySelectorAll('l-product-model').forEach((model) => {
		if (model.modelViewerUI) model.modelViewerUI.play()
	})
	container.querySelectorAll('video').forEach((video) => {
		video.play()
	})
}

/*****************************************
 * [COMPONENT]: MEDIA VIDEO
 ******************************************/

class LTAMediaVideo extends HTMLElement {
	constructor() {
		super()
		this._onClick = this._onClick.bind(this)
		this._onPosterClick = this._onPosterClick.bind(this)
		this._cleanups = []
	}

	connectedCallback() {
		if (this.dataset.videoPlayMode === 'trigger_by_button') {
			this.addEventListener('click', this._onClick)
			this._cleanups.push(() => this.removeEventListener('click', this._onClick))
		}

		const posterEl = this.querySelector('[data-poster]')
		if (!posterEl) return

		posterEl.addEventListener('click', this._onPosterClick)
		this._cleanups.push(() => posterEl.removeEventListener('click', this._onPosterClick))
	}

	disconnectedCallback() {
		this._cleanups.forEach((fn) => fn())
		this._cleanups = []
	}

	_onClick(event) {
		event.preventDefault()
		if (!this.hasAttribute('data-loaded')) {
			this.playVideo()
			return
		}

		this.hasAttribute('data-playing') ? this.pauseVideo() : this.playVideo()
	}

	_onPosterClick(event) {
		event.preventDefault()
		this.playVideo()
	}

	playVideo() {
		document.querySelectorAll('l-media-video').forEach((el) => {
			if (el !== this) el.pauseVideo()
		})

		if (!this.hasAttribute('data-loaded')) {
			const templateEl = this.querySelector('template')
			if (!templateEl) return
			;(this.querySelector('[data-video-container]') || this).append(templateEl.content.cloneNode(true))
			this.toggleAttribute('data-loaded', true)

			this.querySelector('iframe')?.addEventListener(
				'load',
				() => {
					if (this.hasAttribute('data-playing')) l_playMedia(this)
				},
				{ once: true }
			)
		}

		l_playMedia(this)
		this.toggleAttribute('data-playing', true)
	}

	pauseVideo() {
		l_pauseAllMedia(this)
		this.removeAttribute('data-playing')
	}
}

customElements.define('l-media-video', LTAMediaVideo)

/*****************************************
 * [COMPONENT]: SWIPER CAROUSEL
 ******************************************/

class LTASwiperCarousel extends HTMLElement {
	constructor() {
		super()
		this._onLayoutChange = l_debounce(this._onLayoutChange.bind(this), 50)
		this._swiperInitialized = false
	}

	connectedCallback() {
		if (window?.Swiper) {
			this.setupCarousel()
			return
		}

		document.addEventListener('l:vendor:loaded', () => {
			this.setupCarousel()
		})
	}

	disconnectedCallback() {
		this._layoutObserver?.disconnect()
	}

	setupCarousel() {
		if (this._swiperInitialized) return

		const configNode = this.querySelector('[data-carousel-config]')
		if (!configNode) return

		this.carouselConfig = JSON.parse(configNode.textContent)
		if (!this.carouselConfig) return

		this.swiperSlideEls = [...this.querySelectorAll('.swiper-slide')]

		this.classList.remove('is-placeholder')
		this.swiperSlideEls.forEach((swiperSlide) => swiperSlide.classList.remove('l-hidden'))

		this.swiperCarousel = new window.Swiper(this, this.carouselConfig)
		this._swiperInitialized = true

		this._observeLayout()
		this._onLayoutChange()

		if (window.Shopify?.designMode) {
			this.designModeScroll()
		}

		if (this.dataset.dispatchEvent === 'true') {
			this.dispatchEvent(
				new CustomEvent('l:swiper:carousel:loaded', {
					bubbles: true,
					detail: {
						id: this.id || this.dataset.id || 'default',
					},
				})
			)
		}
	}

	_observeLayout() {
		this._layoutObserver?.disconnect()
		this._layoutObserver = new ResizeObserver(this._onLayoutChange)

		this._layoutObserver.observe(this)

		const wrapperEl = this.querySelector('.swiper-wrapper')
		if (wrapperEl) this._layoutObserver.observe(wrapperEl)

		this.swiperSlideEls.forEach((slide) => this._layoutObserver.observe(slide))
	}

	_syncHiddenSlides() {
		if (!this.swiperCarousel) return

		this.swiperSlideEls.forEach((slide) => {
			slide.classList.add('swiper-slide')
			slide.style.removeProperty('display')

			const hidden = getComputedStyle(slide).display === 'none'

			slide.classList.toggle('swiper-slide', !hidden)
			if (hidden) slide.style.display = 'none'
		})

		this.swiperCarousel.update()

		const activeEl = this.swiperCarousel.slides?.[this.swiperCarousel.activeIndex]
		if (!activeEl?.classList.contains('swiper-slide')) {
			this.swiperCarousel.slideTo(0, 0)
		}
	}

	_onLayoutChange() {
		if (!this.swiperCarousel) return

		this._syncHiddenSlides()

		if (this.carouselConfig?.navigation?.navigationHeightTarget) {
			this.setupNavigation()
		}
	}

	setupNavigation() {
		const navigation = this.carouselConfig?.navigation
		if (!navigation || !navigation.navigationHeightTarget) return

		const targetEl = this.querySelector(navigation.navigationHeightTarget)
		if (!targetEl) return

		const navTop = `${targetEl.offsetHeight / 2}px`

		const nextNavEls = document.querySelectorAll(navigation.nextEl)
		const prevNavEls = document.querySelectorAll(navigation.prevEl)

		nextNavEls.forEach((el) => el.style.setProperty('--l-swiper-top', navTop))
		prevNavEls.forEach((el) => el.style.setProperty('--l-swiper-top', navTop))
	}

	designModeScroll() {
		document.addEventListener('shopify:block:select', (event) => {
			const targetEl = event.target

			this.swiperSlideEls.forEach((swiperSlide, index0) => {
				if (targetEl === swiperSlide) this.slideTo(index0)
			})
		})
	}

	slideTo(index = 0) {
		if (this.swiperCarousel && typeof this.swiperCarousel.slideTo === 'function') {
			this.swiperCarousel.slideTo(index)
		}
	}
}

customElements.define('l-swiper-carousel', LTASwiperCarousel)

/*****************************************
 * [COMPONENT]:-DRAWER
 *****************************************/

class LTADrawer extends HTMLElement {
	static #pageInertStack = []

	static #isTopDrawer(drawerEl) {
		return LTADrawer.#pageInertStack.at(-1) === drawerEl
	}

	static #syncDrawerTopClass(removedEl) {
		if (removedEl) removedEl.classList.remove('is-drawer-top')

		const topEl = LTADrawer.#pageInertStack.at(-1) ?? null

		LTADrawer.#pageInertStack.forEach((drawerEl) => {
			drawerEl.classList.toggle('is-drawer-top', drawerEl === topEl)
		})
	}

	static #applyPageInert(activeDrawerEl) {
		const stack = LTADrawer.#pageInertStack

		Array.from(document.body.children).forEach((child) => {
			if (!activeDrawerEl) {
				child.inert = false
				return
			}

			// Keep every stacked drawer (and any body-level ancestor that contains one) interactive
			const isStackedDrawer = stack.includes(child)
			const containsStackedDrawer = stack.some((drawerEl) => child.contains(drawerEl))

			child.inert = !isStackedDrawer && !containsStackedDrawer
		})
	}

	static #pushPageInert(drawerEl) {
		const existingIndex = LTADrawer.#pageInertStack.indexOf(drawerEl)

		if (existingIndex !== -1) {
			LTADrawer.#pageInertStack.splice(existingIndex, 1)
		}

		LTADrawer.#pageInertStack.push(drawerEl)
		LTADrawer.#applyPageInert(drawerEl)
		LTADrawer.#syncDrawerTopClass()
	}

	static #popPageInert(drawerEl) {
		const index = LTADrawer.#pageInertStack.lastIndexOf(drawerEl)

		if (index === -1) return

		LTADrawer.#pageInertStack.splice(index, 1)
		LTADrawer.#applyPageInert(LTADrawer.#pageInertStack.at(-1) ?? null)
		LTADrawer.#syncDrawerTopClass(drawerEl)
	}

	constructor() {
		super()

		this.boundDrawerCloseOutsideOnClick = this.drawer_closeOutsideOnClick.bind(this)
		this.boundDrawerCloseOutsideOnEscape = this.drawer_closeOutsideOnEscape.bind(this)
		this.boundDrawerTriggerOnClick = this.drawer_triggerOnClick.bind(this)
		this.boundDrawerCloseOnClick = this.drawer_closeOnClick.bind(this)
		this.boundDrawerOpenHandler = this.drawer_onOtherDrawerOpen.bind(this)
	}

	connectedCallback() {
		this.setupDrawer()
	}

	disconnectedCallback() {
		this.drawer_destroy()
	}

	setupDrawer() {
		const showInBody = this.dataset.showInBody === 'true'

		// Move to body first; appendChild reconnects the element and runs setupDrawer again.
		// Must work for drawers outside #main-content too (e.g. global-group Age Gate).
		if (showInBody && this.parentElement !== document.body) {
			document.body.appendChild(this)
			return
		}

		if (this._drawerInitialized) return

		const templateEl = this.querySelector('template')
		if (templateEl) {
			const templateContentEl = templateEl.content.cloneNode(true)
			this.appendChild(templateContentEl)
		}

		this.drawer_init()
		this._drawerInitialized = true
	}

	drawer_destroy() {
		if (this.classList.contains('is-active')) {
			this.drawer_close()
		}

		if (this.triggerSelector) {
			document.removeEventListener('click', this.boundDrawerTriggerOnClick)
		}

		this.removeEventListener('click', this.boundDrawerCloseOnClick)
		document.removeEventListener('l:drawer:open', this.boundDrawerOpenHandler)
		window.removeEventListener('click', this.boundDrawerCloseOutsideOnClick)
		window.removeEventListener('keyup', this.boundDrawerCloseOutsideOnEscape)

		this._drawerInitialized = false
	}

	drawer_init() {
		this.triggerSelector = this.dataset.triggerSelector
		this.closeSelector = this.dataset.closeSelector || ''
		this.drawerInnerEl = this.querySelector('[data-drawer-inner]')
		this.triggerEl = null
		this.onlyOneDrawerOpen = this.dataset.onlyOneDrawerOpen === 'true'
		this.drawerName = this.dataset.drawerName || 'drawer'
		this.stackOver = (this.dataset.stackOver || '').trim().split(/\s+/).filter(Boolean)

		if (this.onlyOneDrawerOpen) {
			document.addEventListener('l:drawer:open', this.boundDrawerOpenHandler)
		}

		if (this.triggerSelector) {
			document.addEventListener('click', this.boundDrawerTriggerOnClick)
		}

		this.addEventListener('click', this.boundDrawerCloseOnClick)
		this.drawer_syncTriggerA11y(false)
	}

	drawer_getTriggerEls() {
		if (!this.triggerSelector) return []

		return Array.from(document.querySelectorAll(this.triggerSelector))
	}

	drawer_syncTriggerA11y(isExpanded) {
		this.drawer_getTriggerEls().forEach((triggerEl) => {
			if (this.id && !triggerEl.hasAttribute('aria-controls')) {
				triggerEl.setAttribute('aria-controls', this.id)
			}

			if (!triggerEl.hasAttribute('aria-haspopup')) {
				triggerEl.setAttribute('aria-haspopup', 'dialog')
			}

			triggerEl.setAttribute('aria-expanded', String(isExpanded))
		})
	}

	drawer_setDialogA11y(isOpen) {
		if (isOpen) {
			this.removeAttribute('aria-hidden')
			this.removeAttribute('tabindex')
		} else {
			this.setAttribute('aria-hidden', 'true')
			this.setAttribute('tabindex', '-1')
		}
	}

	drawer_lockPageInert() {
		LTADrawer.#pushPageInert(this)
	}

	drawer_unlockPageInert() {
		LTADrawer.#popPageInert(this)
	}

	drawer_triggerOnClick(event) {
		const triggerEl = event.target.closest(this.triggerSelector)
		if (!triggerEl) return

		event.preventDefault()
		this.drawer_open(triggerEl)
	}

	drawer_closeOnClick(event) {
		const internalCloseEl = event.target.closest('[data-close]')

		if (internalCloseEl && this.contains(internalCloseEl)) {
			this.drawer_close()
			return
		}

		if (this.closeSelector && event.target.closest(this.closeSelector)) {
			this.drawer_close()
		}
	}

	drawer_onOtherDrawerOpen(event) {
		const { drawerName, stackOver = [] } = event.detail || {}

		if (drawerName === this.drawerName) return

		// Incoming drawer stacks over this one — stay open underneath
		if (stackOver.includes(this.drawerName)) return

		this.drawer_close()
	}

	drawer_open(triggerEl) {
		l_setupVariablesBeforeOpenModal()
		l_lockBodyScroll(this.drawerName)

		// Open drawer
		this.classList.remove('l-hidden')

		requestAnimationFrame(() => {
			this.classList.add('is-active')
		})

		// Setup focus trap on main content
		if (triggerEl) {
			this.triggerEl = triggerEl
			l_trapFocus(this.drawerInnerEl, this.defaultElementToFocus, this.enableFocusRange !== false)
		}

		// Set up accessibility
		this.drawer_setDialogA11y(true)
		this.drawer_syncTriggerA11y(true)
		this.drawer_lockPageInert()

		// Set global events using bound handlers
		window.addEventListener('click', this.boundDrawerCloseOutsideOnClick)
		window.addEventListener('keyup', this.boundDrawerCloseOutsideOnEscape)

		// Dispatch event to notify that the drawer is open
		document.dispatchEvent(
			new CustomEvent('l:drawer:open', {
				detail: {
					drawerName: this.drawerName,
					stackOver: this.stackOver,
				},
			})
		)
	}

	drawer_close() {
		l_unLockBodyScroll(this.drawerName)

		// Close drawer
		this.classList.remove('is-active')
		this.classList.remove('is-drawer-top')

		window.l_debounce(() => {
			this.classList.add('l-hidden')
		}, 400)()

		// Remove focus trap
		if (this.triggerEl) {
			l_removeTrapFocus(this.triggerEl)
			this.triggerEl = null
		}

		// Remove accessibility
		this.drawer_setDialogA11y(false)
		this.drawer_syncTriggerA11y(false)
		this.drawer_unlockPageInert()

		// Remove global events using the same bound handlers
		window.removeEventListener('click', this.boundDrawerCloseOutsideOnClick)
		window.removeEventListener('keyup', this.boundDrawerCloseOutsideOnEscape)
	}

	drawer_closeOutsideOnClick(event) {
		if (event._lDrawerHandled) return
		if (!this.classList.contains('is-active')) return
		if (!LTADrawer.#isTopDrawer(this)) return

		const target = event.target
		// Same click closed/interacted with another drawer (e.g. its [data-close]) — ignore
		const sourceDrawer = typeof target.closest === 'function' ? target.closest('.l-drawer') : null
		if (sourceDrawer && sourceDrawer !== this) return

		const triggerSelector = this.dataset.drawerTriggerSelector || 'l-drawer-trigger'
		const isDrawerTrigger = target.closest(triggerSelector)

		const isTriggerClick = this.triggerSelector && target.closest(this.triggerSelector)
		const isOutsideClick = !this.drawerInnerEl.contains(target) && !isTriggerClick && !isDrawerTrigger

		if (!isOutsideClick) return

		event._lDrawerHandled = true
		this.drawer_close()
	}

	drawer_closeOutsideOnEscape(event) {
		if (event._lDrawerHandled || event.defaultPrevented) return
		if (!this.classList.contains('is-active')) return
		if (!LTADrawer.#isTopDrawer(this)) return

		if (event.code.toUpperCase() !== 'ESCAPE') return

		event.preventDefault()
		event._lDrawerHandled = true
		this.drawer_close()
	}
}

customElements.define('l-drawer', LTADrawer)

class LTACollapsibleTab extends HTMLElement {
	constructor() {
		super()

		this._onTriggerClick = (e) => this.toggle(e)
		this._onTriggerKeydown = (e) => this._handleTriggerKeydown(e)
	}

	connectedCallback() {
		this.triggerEl = this.querySelector('[data-trigger]')
		this.contentEl = this.querySelector('[data-content]')

		if (!this.triggerEl || !this.contentEl) return

		this.expandedClass = 'is-expanded'
		this.collapsedClass = 'is-collapsed'
		this.collapsedHeight = '0px'
		this.oneAtATime = true
		this.isScrollIntoView = this.dataset.scrollIntoView === 'true'
		this.trapFocus = this.dataset.trapFocus !== 'false'
		this.keyboardNav = this.dataset.keyboardNav === 'true'

		this.transitionendEvent = this.transitionendEventName()

		this.dataset.oneOpen === 'false' && (this.oneAtATime = false)

		if (this.getAttribute('open') === 'true') {
			this.selected = true
			this.contentEl.removeAttribute('hidden')
			this.contentEl.classList.remove('l-hidden')
			this.classList.add(this.expandedClass)
			this.setExpandedAria(false)
		} else {
			this.contentEl.style.height = this.collapsedHeight
			this.classList.add(this.collapsedClass)
			this.setCollapsedAria(null, false)
		}

		this.triggerEl.addEventListener('click', this._onTriggerClick)

		if (this.keyboardNav) {
			this.triggerEl.addEventListener('keydown', this._onTriggerKeydown)
		}
	}

	disconnectedCallback() {
		this.triggerEl?.removeEventListener('click', this._onTriggerClick)
		this.triggerEl?.removeEventListener('keydown', this._onTriggerKeydown)
	}

	_getAccordionTriggers(container) {
		return Array.from(container.querySelectorAll('l-collapsible-tab[data-keyboard-nav="true"]'))
			.filter((tab) => {
				if (tab.hidden || tab.classList.contains('l-hidden')) return false

				const item = tab.hasAttribute('data-faq-item') ? tab : tab.closest('[data-faq-item]')

				return item && !item.hidden && !item.classList.contains('l-hidden')
			})
			.map((tab) => tab.querySelector('[data-trigger]'))
			.filter((triggerEl) => triggerEl && isVisible(triggerEl))
	}

	_handleTriggerKeydown(event) {
		if (!this.keyboardNav) return

		const key = event.code?.toUpperCase()
		const navigationKeys = ['ARROWDOWN', 'ARROWUP', 'HOME', 'END']

		if (!navigationKeys.includes(key)) return

		const container =
			this.closest('[data-faq-category]') ||
			this.closest('[data-faq-list]') ||
			this.closest('[data-collapsible-wrapper]') ||
			this.parentElement

		if (!container) return

		const triggers = this._getAccordionTriggers(container)
		const currentIndex = triggers.indexOf(this.triggerEl)

		if (currentIndex === -1 || triggers.length < 2) return

		event.preventDefault()

		let nextIndex = currentIndex

		if (key === 'ARROWDOWN') {
			nextIndex = (currentIndex + 1) % triggers.length
		} else if (key === 'ARROWUP') {
			nextIndex = (currentIndex - 1 + triggers.length) % triggers.length
		} else if (key === 'HOME') {
			nextIndex = 0
		} else if (key === 'END') {
			nextIndex = triggers.length - 1
		}

		triggers[nextIndex]?.focus()
	}

	toggle(e) {
		e.preventDefault()

		this.selected ? this.close() : this.open()

		/* Close another tab and open only the current tab. */
		if (this.selected && this.oneAtATime) {
			const tabsContainer = this.closest('[data-collapsible-wrapper]')
			const collapsibleTabs = tabsContainer?.querySelectorAll('l-collapsible-tab')

			collapsibleTabs?.length &&
				collapsibleTabs.forEach((tab) => {
					tab !== this && tab.selected && tabsContainer !== tab && tab.close()
				})
		}
	}

	open() {
		this.selected = true
		this.expand()

		this.setExpandedAria(this.trapFocus)
	}

	close() {
		this.selected = false
		this.collapse()

		this.setCollapsedAria(this.triggerEl, this.trapFocus)
	}

	expand() {
		const onTransitionEnd = ((event) => {
			if (event.target === this.contentEl) {
				this.contentEl.removeEventListener(this.transitionendEvent, onTransitionEnd)

				this.isOpen &&
					requestAnimationFrame(() => {
						this.contentEl.style.transition = '0'
						this.contentEl.style.height = 'auto'

						requestAnimationFrame(() => {
							this.contentEl.style.height = null
							this.contentEl.style.transition = null
						})
					})
			}
		}).bind(this)

		this.contentEl.addEventListener(this.transitionendEvent, onTransitionEnd)
		this.isOpen = true

		this.contentEl.removeAttribute('hidden')
		this.contentEl.classList.remove('l-hidden')

		this.classList.add(this.expandedClass)
		this.classList.remove(this.collapsedClass)

		this.contentEl.style.height = this.contentEl.scrollHeight + 'px'
	}

	collapse() {
		const onTransitionEnd = ((event) => {
			if (event.target === this.contentEl) {
				this.contentEl.removeEventListener(this.transitionendEvent, onTransitionEnd)

				if (!this.isOpen) {
					this.classList.add(this.collapsedClass)
				}

				this.contentEl.setAttribute('hidden', 'hidden')
				this.contentEl.classList.add('l-hidden')
			}
		}).bind(this)

		this.contentEl.addEventListener(this.transitionendEvent, onTransitionEnd)
		this.isOpen = false
		this.classList.remove(this.expandedClass)

		requestAnimationFrame(() => {
			this.contentEl.style.transition = '0'
			this.contentEl.style.height = this.contentEl.scrollHeight + 'px'

			requestAnimationFrame(() => {
				this.contentEl.style.transition = null
				this.contentEl.style.height = this.collapsedHeight
			})
		})

		if (this.isScrollIntoView) {
			l_debounce(() => {
				this.scrollIntoView({ behavior: 'smooth', block: 'center' })
			}, 400)()
		}
	}

	destroy() {
		// Remove event listener using the same stored reference
		this.triggerEl && this.triggerEl.removeEventListener('click', this._onTriggerClick)
		this.contentEl && this.contentEl.removeAttribute('aria-hidden')
		this.contentEl && (this.contentEl.style.height = 'auto')

		this.classList.remove(this.expandedClass, this.collapsedClass)
		this.removeAttribute('open')
	}

	transitionendEventName() {
		let eventName,
			testElement = document.createElement('div'),
			eventNames = {
				transition: 'transitionend',
				OTransition: 'otransitionend',
				MozTransition: 'transitionend',
				WebkitTransition: 'webkitTransitionEnd',
			}

		for (eventName in eventNames) {
			if (eventNames.hasOwnProperty(eventName) && testElement.style[eventName] !== false) {
				return eventNames[eventName]
			}
		}
	}

	setExpandedAria(autoFocus = true) {
		this.setAttribute('open', true)

		this.triggerEl.setAttribute('aria-expanded', 'true')
		this.contentEl.removeAttribute('aria-hidden')
		this.contentEl.removeAttribute('tabindex')
		l_enableFocusableElements(this.contentEl)

		if (autoFocus && this.trapFocus) {
			l_trapFocus(this)
		}
	}

	setCollapsedAria(elementToFocus = this.triggerEl, enableTrapFocus = true) {
		this.removeAttribute('open')

		this.triggerEl.setAttribute('aria-expanded', 'false')
		this.contentEl.setAttribute('aria-hidden', 'true')
		this.contentEl.setAttribute('tabindex', '-1')

		l_disableFocusableElements(this.contentEl)
		enableTrapFocus && this.trapFocus && l_removeTrapFocus(elementToFocus)
	}
}

customElements.define('l-collapsible-tab', LTACollapsibleTab)

/*****************************************
 * [GLOBAL-E]: theme hide CSS (same gates as addStyles)
 ******************************************/
;(function () {
	function isGeCssLinkAlreadyOnPage(params) {
		const href = `${params.appUrl}resources/css/${params.mid}/${params.countryCode}`
		return [...document.querySelectorAll('link[href]')].some((link) => link.href.indexOf(href) > -1)
	}

	// Same as GlobaleApp constructor skip + addStyles() in the app script.
	function shouldAddGeHideStyles(params) {
		if (!params || params.checkoutId) return false
		if (!params.masSkipCssFile && isGeCssLinkAlreadyOnPage(params)) return false
		return Array.isArray(params.operatedCountries) && params.operatedCountries.indexOf(params.countryCode) > -1
	}

	function addCustomGeHideStyles() {
		if (document.getElementById('custom-ge-hide-styles')) return
		if (!shouldAddGeHideStyles(window.GLBE_PARAMS)) return

		const style = document.createElement('style')
		style.id = 'custom-ge-hide-styles'
		style.textContent = `
    .custom-ge-hidden,

    .sealsubs-target-element,
    .rebuy-cart__flyout-item-subscription,


    #hp-features-bar .swiper-slide:first-of-type,
    #footer-features .swiper-slide:first-of-type,
    #hp-bestselling-products .subheading {
      display: none !important;
    }

    #hp-bestselling-products .heading__section h2 {
      margin-block-end: 0;
    }`

		document.head.appendChild(style)
	}

	document.addEventListener('glbeParamsSet', addCustomGeHideStyles)

	if (window.GLBE_PARAMS) {
		addCustomGeHideStyles()
		return
	}

	const startedAt = Date.now()
	const pollId = setInterval(() => {
		if (window.GLBE_PARAMS || Date.now() - startedAt >= 2000) {
			clearInterval(pollId)
			addCustomGeHideStyles()
		}
	}, 50)
})()

